import { call, put, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../services/apis";

function* handleFetchDetailed(action) {
  try {    
    const { filtersString, page, limit } = action.payload;
    const response = yield call(API.fetchCommoditySamplingDetailed, {
      filtersString,
      page,
      limit,
    });

    const data = response?.data;
    
    yield put(actions.fetchDetailedSuccess({ data, page, limit }));
  } catch (error) {
    console.error("❌ Detailed saga error:", error);
    yield put(actions.fetchDetailedFailure(error.message || "Unknown error"));
  }
}

export function* commoditySamplingDetailedSaga() {

  yield takeLatest(actions.fetchDetailed.type, handleFetchDetailed);
}

// ✅ Give saga a unique key
export const DETAILED_SAGA_KEY = "commoditySamplingDetailed";